module.exports = __webpack_public_path__ + "images/canonical-card/vote-icon.77ada3615b3c7c1781b4.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/vote-icon.svg
// module id = Nz0R
// module chunks = 0